// What the portal asks /api/portal-drafts for, and what it sends back.
//
// Kept out of useCloudDrafts so it can be tested directly: both of the faults below were
// invisible in a React hook and expensive on screen.
//
// THE FIRM TRAVELS WITH THE REQUEST. api/portal-drafts.js takes a firm account's firm from
// its session, but an administrator sees and writes across firms, so an administrator's
// request has to say which firm it means. Reading without it listed every firm's records in
// a screen labelled for one; saving without it filed the record under "admin" instead of
// the firm, which is where the two VALS statements uploaded on 21 September ended up.
//
// AN INVENTED ID MEANS "NEW". Pages build ids like "lodgment_1789965039941" for their own
// bookkeeping. The column is a uuid and sending an id means "update that draft", so those
// saves were refused outright. Only a real id is passed on; anything else is dropped and
// the server allocates one.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isDraftId = (value) => UUID.test(String(value ?? "").trim());

export function draftListQuery(formType = "", brand = "") {
  const params = new URLSearchParams();
  const type = String(formType || "").trim();
  const firm = String(brand || "").trim();
  if (type) params.set("form_type", type);
  if (firm) params.set("brand", firm);
  return params.toString();
}

export function draftSaveBody({ id, formType, draftName, brand, formData, matter_id } = {}) {
  const body = {
    form_type: formType,
    draft_name: draftName,
    brand: String(brand || "").trim() || undefined,
    matter_id: matter_id || null,
    form_data: formData || {},
  };
  if (isDraftId(id)) body.id = String(id).trim();
  return body;
}
